import { Grid, InputLabel, TextField } from '@mui/material';
import React from 'react';

const InputFields = ({
  disabled,
  multiline,
  width,
  name,
  required,
  label,
  textFieldType,
  value,
  handleIpChange,
  helperText,
}) => {
  return (
    <Grid item xs={6} sm={6} md={width || 3}>
      <InputLabel
        size="small"
        sx={{
          paddingBottom: '10px',
          fontSize: '0.825rem',
          color: 'black',
        }}
        required={required}>
        {label}
      </InputLabel>
      {textFieldType === 'file' ? (
        <TextField
          size="small"
          variant="outlined"
          type={'file'}
          fullWidth
          onChange={e => handleIpChange(e)}
          name={name}
          required={required}
          helperText={helperText}
        />
      ) : (
        <TextField
          size="small"
          variant="outlined"
          type={textFieldType || 'text'}
          fullWidth
          value={value || ''}
          onChange={e => handleIpChange(name, e.target.value)}
          name={name}
          required={required}
          helperText={helperText}
          multiline={multiline || false}
          disabled={disabled || false}
          sx={{
            '& .MuiInputBase-root.Mui-disabled': {
              backgroundColor: 'white',
              color: 'black',
              opacity: 1,
            },
            '& .MuiInputBase-input.Mui-disabled': {
              WebkitTextFillColor: 'black', // ✅ Apply here instead!
            },
            '& .MuiInputLabel-root.Mui-disabled': {
              color: 'rgba(0, 0, 0, 0.6)',
            },
          }}
        />
      )}
    </Grid>
  );
};

export default InputFields;
